import * as React from "react";
const SvgCross = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12.334 1.668 1.667 12.335m0-10.667 10.667 10.667" /></svg>;
export default SvgCross;